import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PurchaseRuleLink, PurchaseRuleLinkTag } from "types";
import { useCollection } from "../../../hooks/useCollection";
import { getAdjustmentValuesFromPurchaseRule } from "../../../models/PricingGroup";
import { getPurchaseRulesFromPurchaseRuleLink } from "../../../models/PurchaseRuleLink";
import { Currency } from "../../Common/Currency";

const getValueElement = (value: number, operation: string, type?: string) => {
    return (
        <span>
            {value > 0 && type && type !== "set" && "+"}
            {operation === "absolute" ? <Currency>{value}</Currency> : <span>{value}%</span>}
        </span>
    );
};

const getFieldValues = (field: string, adjustmentValues: any) => {
    const values = adjustmentValues?.map((values: any) => values[field]) ?? [];
    return values.filter((item: string, index: number) => values?.indexOf(item) === index);
};

export const PriceVariationRange = ({ scheduleId }: { scheduleId: ID }) => {
    const { id: experienceId } = useParams<{ id?: ID }>();
    const [values, setValues] = useState<number[]>([]);
    const [operations, setOperations] = useState<string[]>([]);
    const [types, setTypes] = useState<string[]>([]);

    const { data: purchaseRuleLinks } = useCollection<PurchaseRuleLink>("purchaseRuleLinks", {
        "tags._id": PurchaseRuleLinkTag.SCHEDULE,
        "entities.id": experienceId,
        expand: "purchaseRule",
        limit: 1,
    });

    const purchaseRuleLink = purchaseRuleLinks[0] ?? {};
    const purchaseRules = getPurchaseRulesFromPurchaseRuleLink(purchaseRuleLink);

    const scheduleLinkedPurchaseRules = purchaseRules
        .filter((purchaseRule) => !purchaseRule.deletedAt)
        .filter((purchaseRule) => purchaseRule.meta?.schedules?.includes(scheduleId));

    let adjustmentValues: any = [];

    if (scheduleLinkedPurchaseRules.length > 0) {
        for (const scheduleLinkedPurchaseRule of scheduleLinkedPurchaseRules) {
            const adjustments = getAdjustmentValuesFromPurchaseRule(scheduleLinkedPurchaseRule);
            adjustmentValues = [...adjustmentValues, ...adjustments];
        }
    }

    const calculateRange = () => {
        if (adjustmentValues) {
            setOperations(getFieldValues("adjustmentOperation", adjustmentValues));
            setValues(getFieldValues("adjustmentAmount", adjustmentValues));
            setTypes(getFieldValues("adjustmentType", adjustmentValues));
        }
    };

    useEffect(() => {
        calculateRange();
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [purchaseRuleLinks]);

    return (
        <div>
            {adjustmentValues ? (
                <div>
                    {operations.length === 0 ? (
                        "-"
                    ) : operations.length > 1 || types.length > 1 ? (
                        <span>Varies</span>
                    ) : values.length > 1 ? (
                        <span>
                            {getValueElement(Math.min(...values), operations[0])} to{" "}
                            {getValueElement(Math.max(...values), operations[0])}
                        </span>
                    ) : (
                        <>{getValueElement(values[0], operations[0], types[0])}</>
                    )}
                </div>
            ) : null}
        </div>
    );
};
